import React from 'react'
import loadable from '@loadable/component'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { Box } from '../../components/Core'
import { breakpoints } from '../../utils'

const Logo = loadable(() => import('../Logo'))


const MenuItemsStyle = styled.div`
@media (max-width: ${breakpoints.xxl}px) {
  margin-top: 42px;
}
@media (max-width: ${breakpoints.lg}px) {
  margin-top: 0;
}
`

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
  visibility: visible;
  transition: all 0.3s ease-out;
  &.hidden {
    opacity: 0;
    visibility: hidden;
  }
`

const Drawer = styled.div`
  position: fixed;
  width: 17rem;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  z-index: 999999;
  overflow-y: auto;
  transform: translateX(0);
  transition: all 0.3s ease-out;
  &.hidden {
    transform: translateX(100%);
  }
  .dropdown-menu {
    position: static !important;
    will-change: initial !important;
    transform: initial !important;
    float: none !important;
  }
`

const LogoContainer = styled.div`
  font-weight: 600;
  font-size: 1.25rem;
`

const Offcanvas = ({ show, onHideOffcanvas, comingSoon, children, ...rest }) => {
  const userSettings = useSelector(state => state.user.user_settings)
  const userSessionExpired = useSelector(state => state.user.session_expired)
  const userDarkModeSelector = useSelector(state => state.user.darkMode)
  const userDarkMode = userSessionExpired
    ? userDarkModeSelector
    : typeof userSettings !== 'undefined'
    ? userSettings.dark_mode
    : false

  if (typeof document !== 'undefined') {
    if (show) {
      document.querySelector('html').classList.add('has-offcanvas')
      document.body.classList.add('has-offcanvas')
    } else {
      document.querySelector('html').classList.remove('has-offcanvas')
      document.body.classList.remove('has-offcanvas')
    }
  }

  if(comingSoon === true){
    return (
      <div {...rest}>
        <Overlay className={show ? '' : 'hidden'} onClick={onHideOffcanvas} />
        <Drawer
          style={{ backgroundColor: userDarkModeSelector ? '#19191b' : '#ffffff' }}
          className={show ? '' : 'hidden'}
        >
          <Box
            style={{ height: '100%' }}
            bg={userDarkModeSelector ? '#19191b' : '#ffffff'}
          >
            <Container>
              <div className="p-3">
                <LogoContainer className="mt-2">
                  <Logo onClick={onHideOffcanvas} white={userDarkModeSelector} />
                </LogoContainer>
                <div className="pt-4">{children}</div>
              </div>
            </Container>
          </Box>
        </Drawer>
      </div>
    )
  }

  return (
    <div {...rest}>
      <Overlay className={show ? '' : 'hidden'} onClick={onHideOffcanvas} />
      <Drawer
        style={{ backgroundColor: userDarkMode ? '#19191b' : '#ffffff' }}
        className={show ? '' : 'hidden'}
      >
        <Box
          style={{ height: '100%' }}
          bg={userDarkMode ? '#19191b' : '#ffffff'}
        >
          <Container>
            <div className="p-3">
              <LogoContainer className="mt-2">
                <Logo onClick={onHideOffcanvas} white={userDarkMode} />
              </LogoContainer>

              <MenuItemsStyle>{children}</MenuItemsStyle>
            </div>
          </Container>
        </Box>
      </Drawer>
    </div>
  )
}

export default Offcanvas
